var map = {
	"./033-bm.webp": 1167,
	"./033-cn.webp": 1168,
	"./033.webp": 1169,
	"./13-bm.webp": 1170,
	"./13-cn.webp": 1171,
	"./13.webp": 1172,
	"./3-bm.webp": 1173,
	"./3-cn.webp": 1174,
	"./3.webp": 1175,
	"./angpao-bg-mobile.jpg": 1176,
	"./angpao-bg.jpg": 1177,
	"./angpao-bm.webp": 1178,
	"./angpao-cn.webp": 1179,
	"./angpao.webp": 1180,
	"./button.png": 1181,
	"./close-eye.png": 1182,
	"./coin-1.png": 1183,
	"./coin.png": 1184,
	"./ketupak-open.png": 1185,
	"./ketupak.png": 1186,
	"./ketupak_ribbon.png": 1187,
	"./rain-1.png": 1188,
	"./rain-2.png": 1189,
	"./rain-3.png": 1190,
	"./raya-bg-mobile.png": 1191,
	"./raya-bg.png": 1192,
	"./shine.png": 1193,
	"./star-1.png": 1194,
	"./star-2.png": 1195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 358;